import { addDays, format } from "date-fns"

interface UpdateInformationFormatted {
    newDueDate: string;
    email: string;
}

export class BillingUpdateInformationModel {
    newDueDate: Date|string = addDays(new Date(), 7)
    email: string = ''

    constructor(b?:Partial<BillingUpdateInformationModel>) {
        Object.assign(this, b)
    }

    getInformationFormatted():UpdateInformationFormatted {
        return {
            newDueDate: format(this.newDueDate as Date, 'yyyy-MM-dd'),
            email: this.email,
        }
    }

    isValid():boolean {
        return !!this.newDueDate && !!this.email
    }
}

